// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog_BhepA {
  max-width: 496px;
  min-height: 520px;
  display: flex;
  flex-direction: column;
}

.iconBackground_av9mB {
  height : '24px'; 
  width : '24px';
  border-radius : '2px'; 
  background-color : '#F0F6FF';
  color : 'pink';
  display : 'flex';
  justify-content : 'center'; 
  align-items : 'center';
  position : 'relative';
}

.button_CYBQa {
  min-width: 128px;
}

.dialogHeader_Prt9g {
  padding: var(--size-pad12) var(--size-padLarge);
  border-bottom: 1px solid var(--color-base100);
}

.headerIcon_ZgDy6 {
  background-color: #D0EBFF;
  width: 24px;
  height: 24px;
}
.headerIcon_ZgDy6 > i {
  font-size: 10px;
}

.dialogBody_dFslD {
  flex: 1;
  padding: var(--size-padLarge);
  background-color: var(--color-base050);
}
.dialogBody_dFslD > * + * {
  margin-top: var(--size-padLarge);
}

.dialogFooter_UPOGN {
  padding: var(--size-padLarge);
  border-top: 1px solid var(--color-base100);
}

.formLabel_LALjt {
  margin-bottom: var(--size-padSmall);
}

/* Overriding default Toast's styling */
.toast_tnp6i {
  border-radius: var(--size-borderRadiusMedium) !important;
  min-height: 40px !important;
  padding: var(--size-padMedium) !important;
}
.toast_tnp6i > button {
  margin-top: 0 !important;
  width: 24px !important;
  height: 24px !important;
}

.icon_aD2Vz {
  width: 24px;
  margin-left : 8px;
  margin-right : 8px;
}

.input_lYp8B {
  padding-left : 0px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/recovrGeneric/ownershipTransfer/actions/initiateAssetTransfer/Classes.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,6BAA6B;EAC7B,sCAAsC;AACxC;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;AACrC;;AAEA,uCAAuC;AACvC;EACE,wDAAwD;EACxD,2BAA2B;EAC3B,yCAAyC;AAC3C;AACA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".dialog {\n  max-width: 496px;\n  min-height: 520px;\n  display: flex;\n  flex-direction: column;\n}\n\n.iconBackground {\n  height : '24px'; \n  width : '24px';\n  border-radius : '2px'; \n  background-color : '#F0F6FF';\n  color : 'pink';\n  display : 'flex';\n  justify-content : 'center'; \n  align-items : 'center';\n  position : 'relative';\n}\n\n.button {\n  min-width: 128px;\n}\n\n.dialogHeader {\n  padding: var(--size-pad12) var(--size-padLarge);\n  border-bottom: 1px solid var(--color-base100);\n}\n\n.headerIcon {\n  background-color: #D0EBFF;\n  width: 24px;\n  height: 24px;\n}\n.headerIcon > i {\n  font-size: 10px;\n}\n\n.dialogBody {\n  flex: 1;\n  padding: var(--size-padLarge);\n  background-color: var(--color-base050);\n}\n.dialogBody > * + * {\n  margin-top: var(--size-padLarge);\n}\n\n.dialogFooter {\n  padding: var(--size-padLarge);\n  border-top: 1px solid var(--color-base100);\n}\n\n.formLabel {\n  margin-bottom: var(--size-padSmall);\n}\n\n/* Overriding default Toast's styling */\n.toast {\n  border-radius: var(--size-borderRadiusMedium) !important;\n  min-height: 40px !important;\n  padding: var(--size-padMedium) !important;\n}\n.toast > button {\n  margin-top: 0 !important;\n  width: 24px !important;\n  height: 24px !important;\n}\n\n.icon {\n  width: 24px;\n  margin-left : 8px;\n  margin-right : 8px;\n}\n\n.input {\n  padding-left : 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog": `dialog_BhepA`,
	"iconBackground": `iconBackground_av9mB`,
	"button": `button_CYBQa`,
	"dialogHeader": `dialogHeader_Prt9g`,
	"headerIcon": `headerIcon_ZgDy6`,
	"dialogBody": `dialogBody_dFslD`,
	"dialogFooter": `dialogFooter_UPOGN`,
	"formLabel": `formLabel_LALjt`,
	"toast": `toast_tnp6i`,
	"icon": `icon_aD2Vz`,
	"input": `input_lYp8B`
};
export default ___CSS_LOADER_EXPORT___;
